import type { GranularityType } from "@shared-server/api/routers/queries/metrics/utils";

export function formatGranularDateTick(
  value: string,
  granularity: GranularityType,
): string {
  if (!value) return "";
  if (granularity === "day") {
    const date = new Date(value);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  }
  if (granularity === "week") {
    const [year, week] = value.split("-W");
    return `W${week} ${year}`;
  }
  if (granularity === "month") {
    const [year, month] = value.split("-");
    return `${new Date(Number(year), Number(month) - 1).toLocaleString(
      "en-US",
      {
        month: "short",
      },
    )} ${year}`;
  }
  if (granularity === "year") {
    return value;
  }
  return value;
}

export const COLORS = ["#006e96", "#eaaa00", "#3e979c", "#53b69a"];
